import React from 'react';
import { useContextSelector } from 'use-context-selector';
import { CatalogContext } from '@context/catalog.context';
import { useTranslation } from 'next-i18next';
import Button from '@components/atoms/button/button';
import ChipList from '@components/catalog/chip-list/chip-list';
import SuggestedSearchQuery from '@components/catalog/product-search/suggested-search-query/suggested-search-query';
import styles from './current-refinements.module.scss';
import ExpandChipsWrapper from './expand-chips-wrapper/expand-chips-wrapper';

const CurrentRefinements: React.FC = (): React.JSX.Element => {
  const { t } = useTranslation();
  const removeAllFilters = useContextSelector(CatalogContext, (v) => v.removeAllFilters);
  const filterChips = useContextSelector(CatalogContext, (v) => v.filterChips);
  const searchQuery = useContextSelector(CatalogContext, (v) => v.searchQuery);

  const hasChips = filterChips && filterChips.length > 0;

  return (
    <div className={styles.currentRefinements__wrapper}>
      <div
        className={styles.currentRefinements}
        data-cy={'current-refinements'}
      >
        {searchQuery && (
          <div>
            <span className={styles.currentRefinements__manualSearchTitle}>{searchQuery}</span>
          </div>
        )}
        {hasChips && (
          <>
            <ExpandChipsWrapper chips={filterChips}>
              {(chips) => (
                <ChipList
                  chips={chips}
                  chipClassName={styles.currentRefinements__badge}
                />
              )}
            </ExpandChipsWrapper>
            <Button
              key="clear-filter"
              disableDefaultStyling
              className={styles.currentRefinements__clearFilters}
              onClick={removeAllFilters}
            >
              {t('CATALOG.FILTERS.CLEAR')}
            </Button>
          </>
        )}
      </div>
      <SuggestedSearchQuery />
    </div>
  );
};

export default CurrentRefinements;
